import React from 'react';
import './index.css';

import { fullpageApi } from "@fullpage/react-fullpage";
import ScrollDownBtn from "../../components/ScrollDownBtn";
import ScrollUpBtn from "../../components/ScrollUpBtn";
import { additionalOfferingsMap } from "../../config/config";
import useKeyDownHandler from "../../hooks/useKeyDown";

interface P {
    sectionId?: string
    activePageId: string
    i18nMap: any
    fullpageApi: fullpageApi
    selectedOfferings: string[]
    addOrRemoveOffering: any
    disableFields: boolean

}

export default ({ sectionId = 'step4', activePageId, i18nMap, fullpageApi, selectedOfferings, addOrRemoveOffering, disableFields, }: P) => {

    const handleKeyDown = useKeyDownHandler({ onAction: addOrRemoveOffering });

    const isActive: boolean = activePageId === sectionId;

    return (
        <div id={sectionId} className={`header header-roof section`}>
            <div className={`outer-step`}>
                <ScrollUpBtn onClick={() => fullpageApi.moveSectionUp()} label={i18nMap.backToTeaser} />
                <div className="sub-step-title">
                    <div className="sub-step-title-left">
                        <span className="roof-icon-label"><i className="fa fa-bolt" /></span>
                        {i18nMap.additionalOfferings}
                    </div>
                </div>
                <div className={`inner-step step-3`}>
                    <div className={`image-items-holder offerings-holder`}>
                        {additionalOfferingsMap.map((item, key) =>
                            <div className={`offering-holder ${selectedOfferings.includes(item.i18nName) && 'image-item-holder-selected-2'} ${disableFields && 'disabled-field'}`} key={key} onClick={() => !disableFields && addOrRemoveOffering(item.i18nName)}>
                                {selectedOfferings.includes(item.i18nName) && <div className={`selected-tick`}>
                                    <i className="fa fa-check basic-icon" aria-hidden="true"></i>
                                </div>}

                                <div
                                    id={item.i18nName}
                                    tabIndex={isActive ? 0 : -1}
                                    className={`offering-image image-item-holder`}
                                    onKeyDown={(e) => !disableFields && handleKeyDown(e, item.i18nName)}
                                >
                                    <img src={`/assets/${item.imgName}`} className={`image-item-img`} alt={''} />

                                </div>

                                <div className={`offering-verbose`}>
                                    <div className={`image-item non-selectable`}>{i18nMap[item.i18nName]}</div>
                                    {i18nMap[item.i18nVerbose]}
                                </div>

                            </div>
                        )}
                    </div>
                </div>
                <p className={`offerings-hint`}>{i18nMap.offeringsHint}</p>
                <ScrollDownBtn onClick={() => fullpageApi.moveSectionDown()} label={i18nMap.nextToContact} />
            </div>
        </div>
    );
}